<ng-template #summaryModal>
    <div class="modal-header">
        <h4 style="margin-bottom: 0px;">{{ui?.currLoc?.name}}</h4>
    </div>
    <div class="modal-body">
        <div>
            <app-box-chart [data]="ui?.charts?.assetSeverity.data" [mapping]="ui?.charts?.assetSeverity.mapping"
                (chartClicked)="onChartClicked('assetSeverity', $event)"></app-box-chart>
        </div>
        <div class=" d-flex mt-3" style="width: 100%; justify-content: space-between;">
            <div [ngClass]="{'bounce-top': ui?.currSelected}">
                <strong>{{ui?.filteredName}}</strong>
                <div class="btn btn-sm btn-primary ml-2" (click)="goToLocation(ui.filteredId)">
                    {{'Go' | translate}}
                </div>
                <div class="btn btn-sm btn-secondary ml-2 get-report-btn" style="position: relative; z-index: 1">
                    <span>{{'Get Reports' | translate}}</span>
                    <div class="card" style="position: absolute; top: -2px; right: -76px; z-index: 1; width: 7em;">
                        <div class="card-body">
                            <div class="d-flex flex-column">
                                <div (click)="generateReport(ui?.currLoc?.id)" class="report-btn btn-blue-hover">{{'Facility' | translate}}</div>
                                <div (click)="generateReport(ui?.filteredId)" class="report-btn btn-blue-hover">{{'Asset' | translate}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="btn btn-sm btn-blue-hover" (click)="ui.isCharts = !ui.isCharts">
                {{ui?.isCharts ? ('Show Tables' | translate) : ('Show Charts' | translate) }}
            </div>
        </div>
        <div class="mt-3" style="display: flex; width: 100%; height: 325px;">
            <ng-container *ngIf="!ui?.isCharts">
                <div style="width: 100%;">
                    <app-annotations-table [locIds]="[ui?.filteredId]"></app-annotations-table>
                </div>
            </ng-container>
            <ng-container *ngIf="ui?.isCharts">
                <div style="width: 50%">
                    <app-basic-linebar-chart [_settings]="{diffColorBars: true, hideAxisVal: true}"
                        [data]="ui?.charts?.severityCount?.data" [mapping]="ui?.charts?.severityCount.mapping">
                    </app-basic-linebar-chart>
                </div>
                <div style="width: 50%">
                    <app-percentage-bar-chart [data]="ui?.charts?.defectTypes?.data"
                        [mapping]="ui?.charts?.defectTypes.mapping">
                    </app-percentage-bar-chart>
                </div>
            </ng-container>
        </div>
    </div>
    <div class="modal-footer">
        <div class="btn btn-sm btn-secondary" (click)="closeModal()">{{ 'Close' | translate }}</div>
    </div>
</ng-template>